export function getDisplayAssetCode(productCode?: string) {
  'worklet';
  if (productCode == null) return null;

  const producCodeUpper = productCode.toUpperCase();
  switch (producCodeUpper) {
    case 'RVX10':
      return 'T10E';
    case 'RVX20':
      return 'T20E';
    case 'RVX5PLAT':
      return 'ECO';
    case 'RVX5PAY':
      return 'PAY';
    case 'RVXDEFI':
      return 'DEFI';
    case 'RVXINFL':
      return 'SHIELD';
    case 'RVXBC10':
      return 'BLUE';
    default:
      return producCodeUpper;
  }
}
